import axios from 'axios';

export const materialsApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/materials`,
    headers: {
        'Content-Type': 'application/json'
    }
})